import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';
import { Chip, Text, styles as dsStyles } from '@frontend/design-system';
import { HOURS_LANE_WIDTH } from './constants';
import { ADJUSTED_ONE_HOUR_IN_MINUTES, zIndex } from './utils';

interface Props {
  hourLabels: string[];
  timezone?: string;
  timezoneTextTopOffset?: number;
}

export const HoursOfTheDay = ({ hourLabels, timezone, timezoneTextTopOffset = 0 }: Props) => {
  const numberOfHours = hourLabels.length;

  return (
    <>
      {!!timezone && <TimezoneText timezone={timezone} timezoneTextTopOffset={timezoneTextTopOffset} />}
      <motion.section layout='position' css={styles.container(numberOfHours)}>
        {hourLabels.map((hour, index) => (
          <motion.div layout='position' key={hour + index} css={styles.item}>
            <Text css={{ margin: 0, userSelect: 'none', marginTop: theme.spacing(-1) }} size='small' color='light'>
              {hour}
            </Text>
          </motion.div>
        ))}
      </motion.section>
    </>
  );
};

const TimezoneText = ({ timezone, timezoneTextTopOffset }: Omit<Props, 'hourLabels'>) => {
  if (!timezone) return null;

  return (
    <div css={[dsStyles.flexCenter, styles.timezoneInfo(timezoneTextTopOffset ?? 0)]}>
      <Chip.TimeZone>{timezone}</Chip.TimeZone>
    </div>
  );
};

const styles = {
  timezoneInfo: (top: number) =>
    css({
      userSelect: 'none',
      position: 'sticky',
      gridColumn: '1 / -1',
      gridRow: '1 / -1',
      width: `${HOURS_LANE_WIDTH}px`,
      left: 0,
      zIndex: zIndex.sidebarHoursSection + 1,
      top,
      height: theme.spacing(4),
      background: theme.colors.neutral5,
      marginTop: theme.spacing(-5),
    }),
  container: (noOfHours: number) =>
    css({
      position: 'sticky',
      zIndex: zIndex.sidebarHoursSection,
      display: 'grid',
      gridColumn: '1 / -1',
      backgroundColor: theme.colors.neutral5,
      gridTemplateRows: `repeat(${noOfHours}, ${ADJUSTED_ONE_HOUR_IN_MINUTES}px)`,
      gridRow: '1 / -1',
      width: `${HOURS_LANE_WIDTH}px`,
      left: 0,
    }),
  item: css({
    textAlign: 'end',
    paddingRight: theme.spacing(2),
  }),
};
